import style from './Main.module.css';
import React, { useRef, useState, useEffect } from "react";
import Countdown from 'react-countdown';

import translate from "../source/lang.json"
import logo_cn from "../source/hand-draw-wedding-chinese-style-full-invitation.png"
import logo_en from "../source/hand-draw-wedding-western-style-full-invitation.png"
import chinese_bg from "../source/chinese-bg.png"
import western_bg from "../source/western-bg.png"
import invite_a_cn from "../source/invite-a-cn.png"
import invite_a_en from "../source/invite-a-en.png"
import invite_d_cn from "../source/invite-d-cn.png"
import invite_d_en from "../source/invite-d-en.png"
import bride_cn from "../source/bride-cn.jpg"
import bride_en from "../source/bride.jpg"
import bridegroom_cn from "../source/bridegroom-cn.jpg"
import bridegroom_en from "../source/bridegroom.jpg"
import both2_cn from "../source/both2-cn.png"
import both2_en from "../source/both2-en.png"
import both3_cn from "../source/both3-cn.png"
import both3_en from "../source/both3-en.png"
import both from "../source/both.jpg"
import bothen from "../source/both-en.jpg"
import map from "../source/fuhotel_map.png"
import map_h from "../source/house_map_h.png"
import map_w from "../source/house_map_w.png"
import thank from "../source/thank.jpg"
import thanken from "../source/thank-en.jpg"
import music from "../source/music.png"
import scrolldown from "../source/scrolldown.webp"
import whatsapp from "../source/whatsapp.png"
import call from "../source/call.png"

import song from "../source/song.mp3";
import { useParams } from 'react-router-dom';

const dinner_date = Date.parse('2023-06-17 18:00:00 +8');

const callback = (entries, observer) => {
  entries.forEach(entry => {
    const target = entry.target.firstChild;
    // console.log('entry.intersectionRatio',entry.intersectionRatio)
    if(entry.intersectionRatio >= 0.75){
        // console.log('set Visible')
        target.classList.add(style.isVisible);
    }else{
        // console.log('remove Visible')
        target.classList.remove(style.isVisible);
    }
  });
}

const loadCN = () => {
    let l = "CN"
    translate[l].bride_img = bride_cn
    translate[l].bridegroom_img = bridegroom_cn
    translate[l].both = both
    translate[l].both2 = both2_cn
    translate[l].both3 = both3_cn
    translate[l].logo = logo_cn
    translate[l].bg = chinese_bg
    translate[l].thank = thank
    translate[l].inviteA = invite_a_cn
    translate[l].inviteD = invite_d_cn
}

const loadEN = () => {
    let l = "EN"
    translate[l].bride_img = bride_en
    translate[l].bridegroom_img = bridegroom_en
    translate[l].both = bothen
    translate[l].both2 = both2_en
    translate[l].both3 = both3_en
    translate[l].logo = logo_en
    translate[l].bg = western_bg
    translate[l].thank = thanken
    translate[l].inviteA = invite_a_en
    translate[l].inviteD = invite_d_en
}

const isWifeOrHusbandLabel = param => param?.toLowerCase().includes('wife') ? "wife" : "husband"

const getLabel = param => {
    let label = 'friend'
    if(param !== undefined){
        param = param.replace('wife','').replace('husband','');
        label = (param.toLowerCase() === 'relative') ? "relative" : label
    }
    return label
}

export default function Invite() {
    const langRef = useRef([])
    const sectionRef = useRef([])
    const rsvpRef = useRef()
    const tqRef = useRef()
    const musicRef = useRef()
    const { label } = useParams()
    const [responseBody, setResponseBody] = useState({id:null, name: "", mobile: "", count: 1, label: label})
    const [loadLocal, setLoadLocal] = useState(false)
    const [hasRSVP, setHasRSVP] = useState(false)
    const [lang, setLang] = useState('CN')

    const [audio] = useState(new Audio(song));
    const [playing, setPlaying] = useState(false);
    const [firstClick, setFirstClick] = useState(0);


    loadCN()
    audio.volume = 0.3;
    // musicRef
    
    audio.oncanplaythrough = () => {  
        // setPlaying(true); 
        audio.play().catch(e => {
            window.addEventListener('click', () => {
                setFirstClick(count => count + 1)
            })
        }); 
    }
    // audio.onended = () => {audio.play()}
    // audio.addEventListener('ended', () => {audio.play(); setPlaying(true);});
    

    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <content>This is the day</content>
        } else {
            // Render a countdown
            return (
                <div className={style.countdown_time}>
                    <group> <value>{days}</value> <unit>{translate[lang].day}</unit> </group>
                    <group> <value>{hours}</value> <unit>{translate[lang].hour}</unit> </group>
                    <group> <value>{minutes}</value> <unit>{translate[lang].min}</unit> </group>
                    <group> <value>{seconds}</value> <unit>{translate[lang].sec}</unit> </group>
                </div>
            );
        }
    };
  
    const inputChangeHandler = (event) => {
        let {name, value} = event.target
        if(name === "mobile"){ value = value.replace(/[^0-9]/g,'')}
        setResponseBody({...responseBody, [name]: value})
    }

    const onSubmitHandler = async (event) => {
        event.preventDefault()
        // console.log(responseBody)
        let resp = await fetch('/action/rsvp', {
            method: 'POST',
            body: JSON.stringify(responseBody),
            headers: {
              'Content-Type': 'application/json'
            },
        })
        let resp_data = await resp.json();
        if (resp_data.resp === "ok"){
            setHasRSVP(true)
            const d = JSON.parse(resp_data.data)
            setResponseBody({
                id: d.id,
                name: d.name,
                mobile: d.mobile,
                count: d.count,
            })
            localStorage.setItem('wed-reg', JSON.stringify(d));
        }

    }

    const changeLanguage = () => {
        if(lang === 'CN'){
            setLang('EN')
            loadEN()
            langRef.current.innerHTML = "CN"
        }else{
            setLang('CN')
            loadCN()
            langRef.current.innerHTML = "EN"
        }
    }

    const MusicToggle = () => {
        // console.log("toggle clicked : playing - ",playing);
        if(playing){
            // console.log('play Music')
            setPlaying(false)
            // console.log('now playing', playing)
            audio.pause();
        }else{
            setPlaying(true)
            // console.log('now pause Music')
            audio.play();
        }
    };


    const RelationSelection = labelFor => {
        const cLabel = getLabel(responseBody.label)
        return (
            <select name='label' onChange={(e)=>inputChangeHandler(e)}>
                <option value={labelFor+"Relative"} selected={(cLabel === 'relative')? "selected" : ""}>{translate[lang].rsvp_option_relative}</option>
                <option value={labelFor+"Friend"} selected={(cLabel === 'friend')? "selected" : ""}>{translate[lang].rsvp_option_friend}</option>
            </select>
        )
    }

    const ContactInformation = labelFor => {
        if(labelFor === 'wife'){
            return (
                <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                    <div className={`${style.container}`}  style={this_style.bg} >
                        <header className={style.textCenter}>{translate[lang].contact_info}</header>
                        <content>{translate[lang].bride_house}</content>
                        <span>&nbsp;</span>
                        <content>{translate[lang].contact_w_dad}</content>
                        <span>
                            <a href='tel:012-4466889'><img src={call} width="40px" alt=''></img></a>
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            <a href='https://wa.me/60194466889'><img src={whatsapp} width="40px" alt=''></img></a>
                        </span>
                        <span>&nbsp;</span>
                        <content>{translate[lang].contact_w}</content>
                        <span>
                            <a href='tel:017-5004046'><img src={call} width="40px" alt=''></img></a>
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            <a href='https://wa.me/60175004046'><img src={whatsapp} width="40px" alt=''></img></a>
                        </span>
                    </div>
                </div>
            )
        }else{
            return (
                <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                    <div className={`${style.container}`}  style={this_style.bg} >
                        <header className={style.textCenter}>{translate[lang].contact_info}</header>
                        <content class={style.textCenter}>{translate[lang].groom_house}</content>
                        <span>&nbsp;</span>
                        <content class={style.textCenter} >{translate[lang].contact_h_gp}</content>
                        <span>
                            <a href='tel:012-6633468'><img src={call} width="40px" alt=''></img></a>
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            <a href='https://wa.me/60126633468'><img src={whatsapp} width="40px" alt=''></img></a>
                        </span>
                        <span>&nbsp;</span>
                        <content class={style.textCenter}>{translate[lang].contact_h}</content>
                        <span>
                            <a href='tel:016-4216021'><img src={call} width="40px" alt=''></img></a>
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            <a href='https://wa.me/60164216021'><img src={whatsapp} width="40px" alt=''></img></a>
                        </span>
                    </div>
                </div>
            )
        }
    }

    const ActualDayInvitation = (labelFor) => {
        const cLabel = getLabel(responseBody.label)
        if ( cLabel === 'relative'){
            if(labelFor === 'wife'){
                return (
                    <>
                    <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                        <div className={`${style.container}`}  style={this_style.bg} >
                            <header class={style.textCenter}>{translate[lang].actual_invite}</header>
                            <img src={translate[lang].inviteA} style={{width: '36%'}} alt=""></img>
                            <hr-short></hr-short>
                            <content>Mr. {translate[lang].groom_name} & Miss. {translate[lang].bride_name}</content>
                            <content>2023-06-13 {translate[lang].tuesday} 9:00 AM</content>
                            <content>（{translate[lang].bride_house}）</content>
                            <span>&nbsp;</span>
                            <span>{translate[lang].a_no_available}</span>
                        </div>
                    </div>

                    <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                        <div className={`${style.container}`}  style={this_style.bg} >
                            <a href='https://goo.gl/maps/Wa96dG7AmNj5onuV9' target="_blank" rel="noreferrer" style={{textAlign:'center'}}>
                                <img src={map_w} style={this_style.map} alt=""></img>
                            </a>
                            <span>&nbsp;</span>
                            <content>- {translate[lang].bride_house} -</content>
                            <span>18, Lorong Santuari 14,<br/> 14000 Bukit Mertajam,<br/> Pulau Pinang</span>
                        </div>
                    </div>

                    <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                        <div className={`${style.container}`}  style={this_style.bg} >
                            <content>【 {translate[lang].a_plan} 】</content>
                            <content>&nbsp;</content>
                            <content>8:30 AM - {translate[lang].aw_830_1}</content>
                            <content>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; {translate[lang].aw_830_2}</content>
                            <content>9:00 AM - {translate[lang].aw_9}</content>
                            <content>10:00 AM - {translate[lang].aw_10}</content>
                            <content>11:00 AM - {translate[lang].aw_11}</content>
                            <content>12:30 PM - {translate[lang].aw_1230}</content>
                        </div>
                    </div>
                    </>
                )
            }else{
                return (
                    <>
                    <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                        <div className={`${style.container}`}  style={this_style.bg} >
                            <header class={style.textCenter}>{translate[lang].actual_invite}</header>
                            <img src={translate[lang].inviteA} style={{width: '36%'}} alt=""></img>
                            <hr-short></hr-short>
                            <content>Mr. {translate[lang].groom_name} & Miss. {translate[lang].bride_name}</content>
                            <content>2023-06-13 {translate[lang].tuesday} 12:00 PM</content>
                            <content>（{translate[lang].groom_house}）</content>
                            <span>&nbsp;</span>
                            <span>{translate[lang].a_no_available}</span>
                        </div>
                    </div>

                    <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                        <div className={`${style.container}`}  style={this_style.bg} >
                            <a href='https://goo.gl/maps/ZvcGLRU5CwvuD4Vo8' target="_blank" rel="noreferrer" style={{textAlign:'center'}}>
                                <img src={map_h} style={this_style.map} alt=""></img>
                            </a>
                            <span>&nbsp;</span>
                            <content>- {translate[lang].groom_house} -</content>
                            <span>46, Lorong Seri Juru 22,<br/>Taman Seri Juru,<br/>14100 Simpang Ampat, Penang</span>
                        </div>
                    </div>

                    <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                        <div className={`${style.container}`}  style={this_style.bg} >
                            <content>【 {translate[lang].a_plan} 】</content>
                            <content>&nbsp;</content>
                            <content>8:00 AM - {translate[lang].ah_8}</content>
                            <content>12:00 PM - {translate[lang].ah_12_1}</content>
                            <content>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; {translate[lang].ah_12_2}</content>
                            <content>1:00 PM - {translate[lang].ah_1_1}</content>
                            <content>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; {translate[lang].ah_1_2}</content>
                            <content>1:30 PM - {translate[lang].ah_130}</content>
                            <content>2:30 PM - {translate[lang].ah_230}</content>
                        </div>
                    </div>
                    </>
                )
            }
        }else { return "" }
    }

    useEffect(()=>{
        console.log("responseBody",responseBody);
        const observer = new IntersectionObserver(callback,{rootMargin:'0px', threshold: 0.75});
        // console.log("load sectionRef",sectionRef)
        sectionRef.current.forEach(section => {
            // console.log("load section",section)
            if(section != null) observer.observe(section);
        })

        if(hasRSVP){
            rsvpRef.current.classList.add(style.hide);
            tqRef.current.classList.remove(style.hide);
        }else{
            rsvpRef.current.classList.remove(style.hide);
            tqRef.current.classList.add(style.hide);
        }

        if(firstClick === 1){
            setPlaying(true)
        }

        if (playing){
            audio.play();
            musicRef.current.classList.add(style.play_music);
        } else { 
            audio.pause();
            musicRef.current.classList.remove(style.play_music);
        }
        
        // console.log('')
        // console.log('firstClick',firstClick)
        // console.log('language',lang);
        // console.log('translate',translate);
        // console.log('playing',playing);
        // console.log('responseBody',responseBody);
        
        // console.log('local storage',localStorage.getItem('wed-reg'));
        // console.log('local storage?',localStorage.getItem("wed-reg") === null);
        if (localStorage.getItem("wed-reg") !== null && !loadLocal) {
            let temp = JSON.parse(localStorage.getItem('wed-reg'));
            // console.log('temp',temp);
            if (temp && temp.id !== undefined && temp.id !== null && temp.id !== "") { 
                setResponseBody(temp) 
                setHasRSVP(true)
            }
            setLoadLocal(true)
        }
        // console.log('responseBody',responseBody);
    },[hasRSVP, playing, firstClick, loadLocal, audio, responseBody])


    const this_style = {
        bg: {
            backgroundColor: '#fff',
            backgroundRepeat: 'no-repeat',
            backgroundPositionX:'right',
            backgroundPositionY: 'center',
            backgroundsize: '600px',
            backgroundImage: `url(${translate[lang].bg})`
        },
        personal_img: {
            width: '60%'
        },
        personal_divider: {
            margin: '5px 75px'
        },
        map: {
            width:'95%'
        },
        music: {
            width: '20px',
            marginTop: '6px'
        },
        scrolldown: {
            position: 'absolute',
            bottom: '30px',
            width: "30%"
        }
    }

    const fixLabel = isWifeOrHusbandLabel(label)
    
    return (
        <>
        <button className={style.float_language} ref={langRef} onClick={changeLanguage}>EN</button>
        <button className={style.float_music} onClick={MusicToggle}>
            <img ref={musicRef} src={music} alt='' style={this_style.music}></img>
        </button>
        <div className={style.main}>
            <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                <div className={style.container}>
                    <img src={translate[lang].logo} width="80%" alt=""></img>
                    <img src={scrolldown} width="150px" alt="" style={this_style.scrolldown}></img>
                </div>
            </div>
            <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                <div className={`${style.container}`}  style={this_style.bg} >
                    <header class={style.textCenter}>{translate[lang].married}</header>
                    <hr-short style={this_style.personal_divider}></hr-short>
                    <img src={translate[lang].both} style={this_style.personal_img} alt=""></img>
                </div>
            </div>
            <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                <div className={`${style.container}`}  style={this_style.bg} >
                    <header class={style.left} >{translate[lang].bride}</header>
                    <hr-short class={style.left} style={this_style.personal_divider}></hr-short>
                    <img className={style.right} src={translate[lang].bride_img} style={this_style.personal_img} alt=""></img>
                    <content className={style.right}>{translate[lang].bride_name}</content>
                </div>
            </div>

            <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                <div className={`${style.container}`}  style={this_style.bg} >
                    <header  class={style.right} >{translate[lang].groom}</header>
                    <hr-short class={style.right} style={this_style.personal_divider}></hr-short>
                    <img className={style.left} src={translate[lang].bridegroom_img} style={this_style.personal_img} alt=""></img>
                    <content className={style.left}>{translate[lang].groom_name}</content>
                </div>
            </div>
            
            <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                <div className={`${style.container}`}  style={this_style.bg} >
                    <content>{translate[lang].love_long}</content>
                    <img src={translate[lang].both3} style={{width:'80%'}} alt=""></img>
                </div>
            </div>
            
            {ActualDayInvitation(fixLabel)}

            <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                <div className={`${style.container}`}  style={this_style.bg} >
                    <header class={style.textCenter}>{translate[lang].dinner_invite}</header>
                    <img src={translate[lang].inviteD} style={{width: '40%'}} alt=""></img>
                    <hr-short></hr-short>
                    <content>Mr. {translate[lang].groom_name} & Miss. {translate[lang].bride_name}</content>
                    <content>2023-06-17 {translate[lang].saturday} 6:00 pm</content>
                    <content>{translate[lang].location}</content>
                </div>
            </div>

            <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                <div className={`${style.container}`}  style={this_style.bg} >
                    <a href='https://goo.gl/maps/DE9hEaQQ9Hne3JTf8' target="_blank" rel="noreferrer" style={{textAlign:'center'}}>
                        <img src={map} style={this_style.map} alt=""></img>
                    </a>
                    <span>&nbsp;</span>
                    <content>- {translate[lang].location_label} -</content>
                    <span>{translate[lang].location}</span>
                </div>
            </div>

            <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                <div className={`${style.container}`}  style={this_style.bg} >
                    <content>【 {translate[lang].plan} 】</content>
                    <content>&nbsp;</content>
                    <content>6:00 PM - {translate[lang].plan_photo}</content>
                    <content>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; {translate[lang].plan_tea}</content>
                    <content>6:45 PM - {translate[lang].plan_entry}</content>
                    <content>7:15 PM - {translate[lang].plan_match_in}</content>
                    <content>7:30 PM - {translate[lang].plan_start}</content>
                </div>
            </div>

            <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                <div className={`${style.container}`}  style={this_style.bg} >
                    <img src={translate[lang].both2} style={{width:'80%'}} alt=""></img>
                    <Countdown date={dinner_date} renderer={renderer} />
                </div>
            </div>
            
            {ContactInformation(fixLabel)}

            <div className={style.section} ref={(element) => {sectionRef.current.push(element); rsvpRef.current = element;}}>
                <div className={`${style.container}`}  style={this_style.bg} >
                    <content>{translate[lang][`${fixLabel}_rsvp`]}</content>
                    <form onSubmit={onSubmitHandler}>
                        <table>
                            <tr>
                                <td>{translate[lang].revp_name}</td>
                                <td>:</td>
                                <td><input name='name' onChange={(e)=>inputChangeHandler(e)} type="text" placeholder={translate[lang].revp_name} value={responseBody.name}></input></td>
                            </tr>
                            <tr>
                                <td>{translate[lang].revp_relation}</td>
                                <td>:</td>
                                <td>{RelationSelection(fixLabel)}</td>
                            </tr>
                            <tr>
                                <td>{translate[lang].revp_mobile}</td>
                                <td>:</td>
                                <td><input name='mobile' onChange={(e)=>inputChangeHandler(e)} type="tel" value={responseBody.mobile} placeholder={translate[lang].revp_mobile} maxLength="12" required></input></td>
                            </tr>
                            <tr>
                                <td>{translate[lang].revp_count}</td>
                                <td>:</td>
                                <td><input name='count' onChange={(e)=>inputChangeHandler(e)} type="number" placeholder={translate[lang].revp_count} value={responseBody.count}></input></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td><input type="submit" value={translate[lang].revp_submit}/></td>
                            </tr>
                        </table>
                    </form>
                    <span>{translate[lang].rsvp_note}</span>
                </div>
            </div>

            <div className={style.section} ref={(element) => {sectionRef.current.push(element); tqRef.current = element;}}>
                <div className={`${style.container}`}  style={this_style.bg} >
                    <content>{translate[lang].dear}{responseBody.name}, {translate[lang].thank_rsvp}</content>
                    <img src={translate[lang].thank} alt="" width="80%"></img>
                    <content>{translate[lang].thank_welcome}</content>
                </div>
            </div>
        </div>
        </>
    );
};
